export const clauses = {
    touristEvent: (minRegistrationsNumber, cancelationTripFinalDate) => {
      const formattedDate = new Date(cancelationTripFinalDate).toLocaleDateString("pl-PL", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
  
      return (
        <div>
          <p>
          Przedstawiony plan wycieczki ma charakter ramowy i może ulec zmianie w przypadku niesprzyjających
          warunków pogodowych lub z przyczyn niezależnych od Organizatora. 
          </p>
          <p>
            Niniejsze wydarzenie <strong>jest imprezą turystyczną</strong> w rozumieniu art. 3 ust. 2 ustawy o imprezach turystycznych i powiązanych usługach turystycznych.
            <strong>Stowarzyszenie Tęczowa Drużyna</strong> z siedzibą w <strong>Krakowie (KRS: 0001016381)</strong> jest Organizatorem Turystyki wpisanym do rejestru prowadzonego przez Urząd Marszałkowski Województwa Małopolskiego pod numerem ewidencyjnym <strong>41885</strong>.
          </p>
          <p>
            Odprowadzamy składki w należnej wysokości do Turystycznego Funduszu Gwarancyjnego celem zabezpieczenia ewentualnych kosztów świadczenia pomocy, w tym kosztów powrotu do kraju, choroby lub śmierci Osoby Podróżującej.
            Zapewniamy Ci ochronę zgodnie z Ogólnymi Warunkami Imprez Turystycznych oraz Gwarancją Ubezpieczeniową <a href="https://www.teczowadruzyna.org/stowarzyszenie/dokumenty" target="_blank" rel="noopener noreferrer">[LINK]</a>.
          </p>
          <p>
            Minimalna liczba osób konieczna do zorganizowania imprezy to <strong>{minRegistrationsNumber}</strong>. Jeżeli nie uzbiera się minimalna grupa, wycieczka może zostać odwołana.
            Poinformujemy Cię o tym pisemnie drogą elektroniczną do dnia <strong>{formattedDate}</strong>. Za odwołanie imprezy przysługuje Ci zwrot pełnej poniesionej kwoty.
          </p>
        </div>
      );
    },
    nonTouristEvent: () => {
        return (
      <div>
        <p>
          Przedstawiony plan wycieczki ma charakter ramowy i może ulec zmianie w przypadku niesprzyjających
          warunków pogodowych lub z przyczyn niezależnych od Organizatora. 
        </p>
        Niniejsze wydarzenie <strong>nie jest imprezą turystyczną</strong> w rozumieniu art. 3 ust. 2 ustawy o imprezach turystycznych i powiązanych usługach turystycznych.
      </div>
    )
    }
};
  